import {
  object, string, date, bool, array,
} from 'yup';

import { DOCUMENT_TYPES } from './document.constants';

// 1. When document is uploaded to the listedkit, the documentId reference stored in the listedkit. task_id = null
// 2. When document is uploaded to the deal, the document has deal_id, task_id and client_id
// 3. When document is uploaded to the client, the document has only client_id
const documentSchema = object({
  id: string(),
  created_on: date().required(),
  updated_on: date().required(),

  name: string().required(),
  file_url: string().required(), // file_url = bucket/filePath

  company_id: string().required(),
  uploader_id: string().required(),
  deal_id: string().nullable(),
  task_id: string().nullable(),
  client_id: string().nullable(),
  template_id: string().nullable(),

  type: string().oneOf(Object.values(DOCUMENT_TYPES)).nullable(),

  is_voided: bool().default(false),
  is_hidden_from_client: bool().default(false),
  meta_data: object({
    roleMapping: array(array(string()).nullable()).nullable(),
  }).nullable(),
});

export default documentSchema;
